export default {
    spacer: "1rem",
    gridGap: "1rem"
};